<template>
  <b-row>
    <b-col>
      <total-with-daily-chart
        :value="totalStatistics.clicks | thousandsFormatter"
        :value-formatter="formatThousands"
        :data="totalDailyStatistics"
        title="Clicks"
        data-value-name="clicks"
      />
    </b-col>
    <b-col>
      <total-with-daily-chart
        :value="totalStatistics.impressions | thousandsFormatter"
        :value-formatter="formatThousands"
        :data="totalDailyStatistics"
        title="Impressions"
        data-value-name="impressions"
      />
    </b-col>
    <b-col>
      <total-with-daily-chart
        :value="totalStatistics.ctr | twoDecimalsFormatter | append('%')"
        :value-formatter="formatCTR"
        :data="totalDailyStatistics"
        title="CTR"
        data-value-name="ctr"
      />
    </b-col>
    <b-col>
      <total-with-daily-chart
        :value="revenueValue()"
        :value-formatter="formatSpent"
        :data="totalDailyStatistics"
        title="Spent"
        data-value-name="spentLocalCurrency"
      />
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import TotalWithDailyChart from './TotalWithDailyChart.vue';

export default Vue.extend({
  components: {
    TotalWithDailyChart,
  },
  computed: {
    ...mapState('advertiser-insights', {
      totalDailyStatistics: state => {
        const dailyTotal = [...state.statistics.totalDaily];
        return dailyTotal.sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        });
      },
      totalStatistics: state => {
        return state.statistics.total;
      },
      currency: state => {
        return (state.filters.selectedCampaign || {}).currency;
      },
    }),
  },
  methods: {
    formatCTR(val) {
      return this.$options.filters.twoDecimalsFormatter(val) + '%';
    },
    formatThousands(val) {
      return this.$options.filters.thousandsFormatter(val);
    },
    formatSpent(val) {
      return this.$options.filters.thousandsFormatter(
        this.$options.filters.round(val, 0)
      );
    },
    revenueValue() {
      return `${this.currency || ''} ${this.formatSpent(
        this.totalStatistics.spentLocalCurrency
      )}`;
    },
  },
});
</script>
